type PlatformUrlsConfig = {
  [key in PlatformUrlType]: (value: string) => string;
}

export const platformUrlsConfig: PlatformUrlsConfig = {
  mail: (value: string) => `mailto:${value}`,
  instId: (value: string) => `https://instagram.com/${value.replace(/^@/, '')}`,
  instagram: (value: string) => `https://instagram.com/${value.replace(/^@/, '')}`,
  whatsappId: (value: string) => `https://wa.me/${value}`,
  whatsapp: (value: string) => `https://wa.me/${value}`,
  whatsappLink: (value: string) => `https://wa.me/${value}`,
  youtubeId: (value: string) => `https://youtube.com/channel/${value}`,
  youtube: (value: string) => `https://youtube.com/channel/${value}`,
  tgId: (value: string) => `https://t.me/${value.replace(/^@/, '')}`,
  telegram: (value: string) => `https://t.me/${value.replace(/^@/, '')}`,
  telegramLink: (value: string) => `https://t.me/${value.replace(/^@/, '')}`,
  vkId: (value: string) => `https://vk.com/${value.replace(/^@/, '')}`,
  vk: (value: string) => `https://vk.com/${value.replace(/^@/, '')}`,
  phoneNumber: (value: string) => `tel:${value}`,
  phone: (value: string) => `tel:${value}`
};

export type PlatformUrlType = 'mail' | 'instId' | 'whatsappId' |
  'youtubeId' | 'tgId' | 'vkId' | 'phoneNumber' | 'instagram' |
  'telegram' | 'vk' | 'whatsapp' | 'youtube' | 'telegramLink' |
  'whatsappLink' | 'phone';

export const platformUrls: PlatformUrlType[] = [
  'mail', 'instId', 'whatsappId', 'youtubeId', 'tgId', 'vkId', 'phoneNumber',
  'instagram', 'telegram', 'vk', 'whatsapp', 'youtube', 'telegramLink',
  'whatsappLink', 'phone'
];
